import React from "react";
import { Box, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { BRAND } from "../lightTheme";
import { formatDt } from "../utils/lightUtils";

/** Highlight @mentions in note content */
function formatNoteContent(text) {
  return (text ?? "").split(" ").map((word) =>
    word.startsWith("@")
      ? `<span style="color:#003A22;background:#CEF4C3;padding:2px 6px;border-radius:12px;font-weight:700">${word}</span>`
      : word
  ).join(" ");
}

/**
 * Reusable note list for Light mode.
 * @param {Array} notes - array of note objects
 * @param {function} onDelete - called with noteOId
 * @param {boolean} canDelete - whether delete button is shown
 * @param {object} classes - { noteItem, noteHeader, noteAuthor, noteDate, noteDeleteBtn, noteContent, mentionAvatar }
 * @param {boolean} [showAvatar=true] - show avatar circle with initials
 */
export default function LightNotesList({ notes, onDelete, canDelete = true, classes: s, showAvatar = true }) {
  if (!notes?.length) return null;

  return (
    <>
      {[...notes].reverse().map((note) => (
        <Box key={note.noteOId} className={s.noteItem}>
          <Box className={s.noteHeader}>
            <Box style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
              {showAvatar && (
                <Box className={s.mentionAvatar} style={!s.mentionAvatar ? { width: "28px", height: "28px", borderRadius: "50%", backgroundColor: BRAND.primary, color: BRAND.white, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.7rem", fontWeight: 700, fontFamily: "Inter", flexShrink: 0 } : undefined}>
                  {note.prenomNom?.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) ?? "?"}
                </Box>
              )}
              <Box>
                <Typography className={s.noteAuthor}>{note.prenomNom}</Typography>
                <Typography className={s.noteDate}>{formatDt(note.dateCreation)}</Typography>
              </Box>
            </Box>
            {canDelete && (
              <button className={s.noteDeleteBtn} onClick={() => onDelete(note.noteOId)}>
                <DeleteOutlineIcon style={{ fontSize: "14px" }} />
              </button>
            )}
          </Box>
          <Typography
            className={s.noteContent}
            dangerouslySetInnerHTML={{ __html: formatNoteContent(note.contenu ?? note.content) }}
          />
        </Box>
      ))}
    </>
  );
}
